import { RenderStateStruct } from '../../type/common.interface';
import { drawBg } from './draw-bg';
import { drawChar } from './draw-char';
import { drawLt } from './draw-lt';
import { drawUl } from './draw-ul';

function drawing(renderStateStruct: RenderStateStruct) {
    const { scheduleRatio, drawRatio, contentArea } = renderStateStruct;
    const { width, height, offset } = contentArea;

    const canvas = new OffscreenCanvas(1, 1);
    const canvasContext = canvas.getContext('2d', { willReadFrequently: true }) as OffscreenCanvasRenderingContext2D;
    canvas.width = width + Math.abs(offset.x);
    canvas.height = height + Math.abs(offset.y);

    // 矩阵变换
    canvas.width = canvas.width * drawRatio;
    canvas.height = canvas.height * drawRatio;
    canvasContext.transform(1 * drawRatio, 0, 0, 1 * drawRatio, 0, 0);

    if (offset.x < 0) canvasContext.translate(-offset.x, 0);
    if (offset.y < 0) canvasContext.translate(0, -offset.y);

    // 绘制Map
    const drawMap = {
        bgStructList: drawBg, // 绘制背景
        charStructList: drawChar, // 绘制字符
        ulStructList: drawUl, // 绘制字符
        ltStructList: drawLt, // 绘制字符
    };

    Object.keys(drawMap).forEach((key) => {
        canvasContext.save();
        renderStateStruct[key].forEach((struct: unknown) => {
            canvasContext.save();
            drawMap[key]({ canvasContext, scheduleRatio, struct });
            canvasContext.restore();
        });
        canvasContext.restore();
    });

    return { canvas, canvasContext };
}

export function draw(renderStateStruct: RenderStateStruct) {
    const { canvasContext } = drawing(renderStateStruct);
    const { drawRatio, contentArea } = renderStateStruct;
    const { width, height, offset } = contentArea;

    const imageData = canvasContext.getImageData(
        Math.max(offset.x, 0) * drawRatio,
        Math.max(offset.y, 0) * drawRatio,
        width * drawRatio,
        height * drawRatio,
    );

    return {
        imageData,
        width: width * drawRatio,
        height: height * drawRatio,
    };
}
